import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase.ts'
import FetchAllEMethodosUseCase from '@/core/useCases/emethodos/FetchAllEMethodosUseCase.ts'
import UpdateEMethodosUseCase from '@/core/useCases/emethodos/UpdateEMethodosUseCase.ts'
import EMethodosRepository from '@/core/infrastructure/repositories/emethodos/EMethodosRepository.ts'

export class EMEthodosModule extends ModuleBase {
  initialize(): void {
    this.initializeCore()
  }

  private initializeCore(): void {
    const eMethodosRepository = new EMethodosRepository()
    this.registerRepository(EMethodosRepository, eMethodosRepository)

    const fetchAllEMethodosUseCase = new FetchAllEMethodosUseCase(eMethodosRepository)
    this.registerUseCase(FetchAllEMethodosUseCase, fetchAllEMethodosUseCase)

    const updateEMethodosUseCase = new UpdateEMethodosUseCase(eMethodosRepository)
    this.registerUseCase(UpdateEMethodosUseCase, updateEMethodosUseCase)
  }
}
